import { render, staticRenderFns } from "./DataQualityOverview.vue?vue&type=template&id=bd71055a&scoped=true&"
import script from "./DataQualityOverview.vue?vue&type=script&lang=js&"
export * from "./DataQualityOverview.vue?vue&type=script&lang=js&"
import style0 from "./DataQualityOverview.vue?vue&type=style&index=0&id=bd71055a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd71055a",
  null
  
)

export default component.exports